import React from 'react';

const PrimaryManagerContext = React.createContext();

export default PrimaryManagerContext;
